import { AxiosResponse } from 'axios';
import { Repository } from '../repository';
import { ITableRepository } from '../../shared/interfaces/repositories/table/table.interface';
import { TableCheckResponse } from '../../shared/types/repositories/table/table-check.type';

export class TableRepository extends Repository implements ITableRepository {
    public check(location: string, table: string): Promise<AxiosResponse<TableCheckResponse>> {
        return this._payRequest.get(`${Repository.API_V1}/check-table/${location}/${encodeURIComponent(table)}/`);
    }

    public getUserTable(location: string, table: string, token: string) {
        return this._backendRequest.post('/user/access/pay/', {
            scope: {
                locations: [location],
            },
            table_id: table,
        }, {
            headers: {
                authorization: `Token ${token}`,
            },
        });
    }
}
